var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notify-list"},_vm._l((_vm.items),function(item){return _c('NotifyItem',{key:item.id,staticClass:"mb-2",attrs:{"type":item.type},on:{"close":function($event){return _vm.onClose(item.id)}}},[_vm._v(" "+_vm._s(item.text)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }